import { HealthCenter, User } from '@silbo/core';
import { createContext } from 'react';

export type AuthenticationContextType = {
  user: User | undefined;
  isAuthenticated: boolean;
  healthCenter: HealthCenter | undefined;
  loading: boolean;
  loginError: string;
  microsoftError: string;

  // Login standard (BedManagement) - username/password classique
  login: (username: string, password: string) => Promise<void>;

  // Login Microsoft SSO (BedManagement)
  microsoftLogin: () => Promise<void>;

  // Login Patient Transport (via QR + PIN)
  loginPorter: (username: string, password: string) => Promise<void>;

  resetLoginError: () => void;
  logout: () => Promise<void>;
};

export const AuthenticationContext = createContext<AuthenticationContextType>({} as AuthenticationContextType);
